export default __webpack_public_path__ + "static/media/colorTwitter.bce602c3.svg";